/**
 * Project views
 * Path: `@/views/project`
 * - Project's edm views: used for document's managment
 * - Company settings views: handle company settings
 * - Project's inspection views
 * - Project's nonconformity views
 */

import multiguard from "vue-router-multiguard"
import { requireAuth, requireNoIsPro, requireBusinessPrivilege } from "@/utils/middleware"
// import store from "@/store" // Assure-toi d'importer ton store

// const General = () => import("@/views/project/General.vue")

const StaffMembers = () => import("@/views/business/staffMembers/StaffMembers.vue")
const StaffCreateUpdate = () => import("@/views/business/staffMembers/StaffCreateUpdate.vue")
const CompanyVehicles = () => import("@/views/business/companyVehicles/CompanyVehicles.vue")
const VehicleCreateUpdate = () => import("@/views/business/companyVehicles/VehicleCreateUpdate.vue")
const Department = () => import("@/views/account/department/Department.vue")
const MainDepartment = () => import("@/views/account/department/MainDepartment.vue")

const CompanyVouchers = () => import("@/views/business/companyVouchers/CompanyVouchers.vue")
const CompanyVouchersHistory = () => import("@/views/business/companyVouchers/CompanyVouchersHistory.vue")
const ClientVouchers = () => import("@/views/business/clientVouchers/ClientVouchers.vue")
const VoucherCreateUpdate = () => import("@/views/business/companyVouchers/VoucherCreateUpdate.vue")


const TransactionDetail = () => import("@/views/business/transaction/TransactionDetail.vue")
const FidelityDetail = () => import("@/views/business/transaction/FidelityDetail.vue")
const AuthorisationDetail = () => import("@/views/business/authorisation/AuthorisationDetail.vue")
const ProductDetail = () => import("@/views/business/product/ProductDetail.vue")

const CityDetail = () => import("@/views/business/city/CityDetail.vue")
const MunicipalityDetail = () => import("@/views/business/municipality/MunicipalityDetail.vue")

const ShopDetail = () => import("@/views/business/shop/ShopDetail.vue")
const CouponDetail = () => import("@/views/activity/coupon/CouponDetail.vue")
const CouponUsersDetail = () => import("@/views/activity/coupon/CouponUsersDetail.vue")

// DRAWERS
const ProjectDrawer = () => import("@/components/layouts/core/ProjectDrawer.vue")
const DonationDetail = () => import("@/views/business/donation/DonationDetail.vue")
const TankList = () => import("@/views/business/tank/TankList.vue")

const RedemptionsAdmin = () => import("@/views/business/redemptions/RedemptionsAdmin.vue")
const VehiclesUsers = () => import("@/views/business/redemptions/VehiclesUsers.vue")
const FidelityStats = () => import("@/views/business/redemptions/FidelityStats.vue")

const ApiKeys = () => import("@/views/business/apiKeys/ApiKeys.vue")
const ApiDocs = () => import("@/views/business/apiKeys/ApiDocs.vue")

const RefillRequestList = () => import("@/views/business/refillRequest/RefillRequestList.vue")
const RefillRequestNew = () => import("@/views/business/refillRequest/RefillRequestNew.vue")


// import { requireStaff } from "@/utils/middleware"  TankList.vue
export default [

  {
    path: "/business/staff",
    name: "StaffMembers",
    component: StaffMembers,
    beforeEnter: multiguard([requireAuth, requireNoIsPro]),
    meta: {
      layout: "default",
      drawer: ProjectDrawer
    }
  },
  {
    path: "/business/vehicle",
    name: "CompanyVehicles",
    component: CompanyVehicles,
    beforeEnter: multiguard([requireAuth, requireNoIsPro]),
    meta: {
      layout: "default",
      drawer: ProjectDrawer
    }
  },
  {
    path: "/business/redemptions-admin",
    name: "RedemptionsAdmin",
    component: RedemptionsAdmin,
    beforeEnter: multiguard([requireAuth, requireNoIsPro]),
    meta: {
      layout: "default",
      drawer: ProjectDrawer
    }
  },
  {
    path: "/business/users-info",
    name: "VehiclesUsers",
    component: VehiclesUsers,
    beforeEnter: multiguard([requireAuth, requireNoIsPro]),
    meta: {
      layout: "default",
      drawer: ProjectDrawer
    }
  },
  {
    path: "/business/fidelity-stats",
    name: "FidelityStats",
    component: FidelityStats,
    beforeEnter: multiguard([requireAuth, requireNoIsPro]),
    meta: {
      layout: "default",
      drawer: ProjectDrawer
    }
  },
  {
    path: "/business/voucher",
    name: "CompanyVouchers",
    component: CompanyVouchers,
    beforeEnter: multiguard([requireAuth, requireNoIsPro]),
    meta: {
      layout: "default",
      drawer: ProjectDrawer
    }
  },
  {
    path: "/account/department",
    name: "CompanyDepartment",
    component: Department,
    beforeEnter: multiguard([requireAuth, requireNoIsPro]),
    meta: {
      layout: "default",
      drawer: ProjectDrawer
    }
  },
  {
    path: "/account/department",
    name: "CompanyDepartment",
    component: Department,
    beforeEnter: multiguard([requireAuth, requireNoIsPro]),
    meta: {
      layout: "default",
      drawer: ProjectDrawer
    }
  },
  {
    path: "/account/main-department",
    name: "MainDepartment",
    component: MainDepartment,
    beforeEnter: multiguard([requireAuth, requireNoIsPro]),
    meta: {
      layout: "default"
    }
  },
  {
    path: "/business/client",
    name: "ClientVouchers",
    component: ClientVouchers,
    beforeEnter: multiguard([requireAuth, requireNoIsPro]),
    meta: {
      layout: "default",
      drawer: ProjectDrawer
    }
  },
  {
    path: "/business/staff/:id?/editor",
    name: "StaffCreateUpdate",
    component: StaffCreateUpdate,
    beforeEnter: multiguard([requireAuth, requireNoIsPro]),
    meta: {
      layout: "default"
    }
  },
  {
    path: "/business/vehicle/:id?/editor",
    name: "VehicleCreateUpdate",
    component: VehicleCreateUpdate,
    beforeEnter: multiguard([requireAuth, requireNoIsPro]),
    meta: {
      layout: "default"
    }
  },
  {
    path: "/business/voucher/:id?/editor",
    name: "VoucherCreateUpdate",
    component: VoucherCreateUpdate,
    beforeEnter: multiguard([requireAuth, requireNoIsPro]),
    meta: {
      layout: "default"
    }
  },
  {
    path: "/business/voucher/:id?/history",
    name: "CompanyVouchersHistory",
    component: CompanyVouchersHistory,
    beforeEnter: multiguard([requireAuth, requireNoIsPro]),
    meta: {
      layout: "default",
      drawer: ProjectDrawer
    }
  },
  {
    path: "/business/donation",
    name: "DonationDetail",
    component: DonationDetail,
    beforeEnter: multiguard([requireAuth]),
    meta: {
      layout: "default",
      drawer: ProjectDrawer
    }
  },
  {
    path: "/business/transaction",
    name: "TransactionDetail",
    component: TransactionDetail,
    beforeEnter: multiguard([requireAuth]),
    meta: {
      layout: "default",
      drawer: ProjectDrawer
    }
  },
  {
    path: "/business/tanks",
    name: "TankList",
    component: TankList,
    beforeEnter: multiguard([requireAuth]),
    meta: {
      layout: "default",
      drawer: ProjectDrawer
    }
  },
  {
    path: "/business/fidelities",
    name: "FidelityDetail",
    component: FidelityDetail,
    beforeEnter: multiguard([requireAuth]),
    meta: {
      layout: "default",
      drawer: ProjectDrawer
    }
  },
  {
    path: "/business/validation", 
    name: "AuthorisationDetail",
    component: AuthorisationDetail,
    beforeEnter: multiguard([requireAuth, requireNoIsPro]),
    meta: {
      layout: "default",
      drawer: ProjectDrawer
    }
  },
  {
    path: "/business/product",
    name: "ProductDetail",
    component: ProductDetail,
    beforeEnter: multiguard([requireAuth, requireNoIsPro]),
    meta: {
      layout: "default",
      drawer: ProjectDrawer
    }
  },
  {
    path: "/business/city",
    name: "CityDetail",
    component: CityDetail,
    beforeEnter: multiguard([requireAuth, requireNoIsPro]),
    meta: {
      layout: "default",
      drawer: ProjectDrawer
    }
  },
  {
    path: "/business/municipality",
    name: "MunicipalityDetail",
    component: MunicipalityDetail,
    beforeEnter: multiguard([requireAuth, requireNoIsPro]),
    meta: {
      layout: "default",
      drawer: ProjectDrawer
    }
  },
  {
    path: "/business/shop",
    name: "ShopDetail",
    component: ShopDetail,
    beforeEnter: multiguard([requireAuth, requireNoIsPro]),
    meta: {
      layout: "default",
      drawer: ProjectDrawer
    }
  },
  {
    path: "/activity/coupon",
    name: "CouponDetail",
    component: CouponDetail,
    beforeEnter: multiguard([requireAuth, requireNoIsPro]),
    meta: {
      layout: "default",
      drawer: ProjectDrawer
    }
  }
  ,
  {
    path: "/activity/coupon-user",
    name: "CouponUsersDetail",
    component: CouponUsersDetail,
    beforeEnter: multiguard([requireAuth, requireNoIsPro]),
    meta: {
      layout: "default",
      drawer: ProjectDrawer
    }
  },
  {
    path: "/business/api-keys",
    name: "ApiKeys",
    component: ApiKeys,
    beforeEnter: multiguard([requireAuth, requireNoIsPro]),
    meta: {
      layout: "default",
      drawer: ProjectDrawer
    }
  },
  {
    path: "/business/api-docs",
    name: "ApiDocs",
    component: ApiDocs,
    beforeEnter: multiguard([requireAuth, requireNoIsPro]),
    meta: {
      layout: "default",
      drawer: ProjectDrawer
    }
  },
  {
    // Liste accessible a tout non-pompiste. Le backend filtre les donnees
    // selon les privileges (BusinessPrivilegePermission + show_refill_request).
    path: "/business/refill-requests",
    name: "RefillRequestList",
    component: RefillRequestList,
    beforeEnter: multiguard([requireAuth, requireNoIsPro]),
    meta: {
      layout: "default",
      drawer: ProjectDrawer
    }
  },
  {
    // Creation reservee aux user qui ont le droit d emettre une demande.
    path: "/business/refill-requests/new",
    name: "RefillRequestNew",
    component: RefillRequestNew,
    beforeEnter: multiguard([
      requireAuth,
      requireNoIsPro,
      requireBusinessPrivilege("edit_refill_request"),
    ]),
    meta: {
      layout: "default",
      drawer: ProjectDrawer
    }
  },
]
